export const apiConfig = {
  publicationBase: process.env.REACT_APP_PUBLICATION_SERVICE || 'http://localhost:4300'
};
